export const PO_DOC_ERROR_TYPE = {
  INVALID_FORMAT: 'invalid_format',
  SIZE_EXCEEDED:  'size_exceeded',
  UPLOAD_FAILED:  'upload_failed',
  MAX_FILES_EXCEEDED: 'max_files_exceeded',
} as const;

export type PoDocErrorType = typeof PO_DOC_ERROR_TYPE[keyof typeof PO_DOC_ERROR_TYPE] | null;

// Labels for the multi-file card — the strings the old single-file template carried inline,
// promoted to constants per the repo's constants-over-magic-strings convention.
export const PO_DOC_LABELS = {
  DROPZONE: 'Drag and drop files here or',
  BROWSE: 'Browse file',
  UPLOADING: 'Uploading…',
  PREVIEW: 'Preview',
  REMOVE: 'Remove',
  DOWNLOAD: 'Download',
} as const;

// Colors for the error banner shown in the document section (file upload errors, missing file).
export const PO_DOC_ERROR_BANNER = {
  BG: '#FFE9E9',
  ICON_COLOR: '#FF441F',
} as const;

export const PO_DOC_FALLBACKS = {
  ALLOWED_MIMES: ['application/pdf'] as string[],
  ALLOWED_EXTENSIONS: ['pdf'] as string[],

  BYTES_PER_MB: 1024 * 1024,

  // Fallbacks for the CMS keys po_document_max_count / po_document_max_size_mb — they mirror the
  // backend defaults (internal/app/cms/cms.go defaultPoDocumentMaxCount/SizeMB). Keep in sync.
  MAX_FILES: 10,
  MAX_SIZE_MB: 20,

  MAX_FILES_EXCEEDED_BANNER: 'Máximo de archivos alcanzado.',
  MAX_FILES_EXCEEDED_ALERT: (maxFiles: number) => `You can upload up to ${maxFiles} files.`,

  INVALID_FORMAT_BANNER: 'Formato no admitido.',
  INVALID_FORMAT_ALERT: 'Only PDF files are accepted.',

  SIZE_EXCEEDED_BANNER: 'El archivo supera el límite permitido.',
  SIZE_EXCEEDED_ALERT: 'File exceeds the maximum allowed size.',

  UPLOAD_FAILED_BANNER: 'Ha ocurrido un error interno al guardar su documento.',
  UPLOAD_FAILED_ALERT: 'Error uploading document. Please try again.',

  UPLOAD_COMPLETE: 'Document uploaded successfully.',

  REMOVED: 'Document removed successfully.',

  FILE_REQUIRED_BANNER: 'Please upload a PDF file',
} as const;
